export default __webpack_public_path__ + "static/media/element_47.af1b3f80.jpg";